export const COOKIE_TOKEN_KEY = "jwt_token";
export const DAY_NUMBER_MAP = {
  Monday: 2,
  Tuesday: 3,
  Wednesday: 4,
  Thurday: 5,
  Friday: 6,
  Saturday: 7,
  Sunday: 1,
};
export const NUMBER_DAY_MAP = {
  1: "Sunday",
  2: "Monday",
  3: "Tuesday",
  4: "Wednesday",
  5: "Thurday",
  6: "Friday",
  7: "Saturday",
};

export const DAY_ORDER = [2, 3, 4, 5, 6, 7, 1];
